import { LogAdmin, logAdminExternal } from '../utils/logging';

let domainUrl = process.env.REACT_APP_BACKEND_URL_LOCAL;
if (process.env.REACT_APP_NODE_ENV === "production") {
	domainUrl = process.env.REACT_APP_BACKEND_URL_HOSTED;
}

let loggingServerUrl = process.env.REACT_APP_BACKEND_URL_LOCAL;
if (process.env.REACT_APP_NODE_ENV === "production") {
	loggingServerUrl = process.env.REACT_APP_LOGGING_URL;
}

function getRequestHeaders() {
	const requestHeaders = new Headers();
	requestHeaders.set("xsrf-token", localStorage.getItem("xsrf-token") as string);
	requestHeaders.set("Accept", "application/json");
	requestHeaders.set("Content-Type", "application/json");
	requestHeaders.set("jwt_token", localStorage.getItem("session-token") as string);
	return requestHeaders;
}
export function fetchGetBackEnd(url: string, logAdmin?: LogAdmin) {
	if (logAdmin) logAdmin("fetch GET to:", `${domainUrl}${url}`);
	return fetch(`${domainUrl}${url}`, {
		method: "GET",
		headers: getRequestHeaders(),
		credentials: "include",
		mode: "cors",
	}); // fetch
}

export function fetchPostBackEnd(url: string, bodyPayload: string, logAdmin?: LogAdmin) {
	if (logAdmin) logAdmin("fetch POST to:", `${domainUrl}${url}`, "with", bodyPayload);
	logAdminExternal({ domainUrl, url })

	return fetch(`${domainUrl}${url}`, {
		method: "POST",
		headers: getRequestHeaders(),
		credentials: "include",
		mode: "cors",
		body: bodyPayload,
	}); // fetch
}

export function fetchPostLoggingServer(url: string, bodyPayload: string, logAdmin?: LogAdmin) {
	const loggingUrl = `${loggingServerUrl}${url}`
	logAdminExternal({ loggingServerUrl, url })

	if (logAdmin) logAdmin("fetch POST to:", loggingUrl, "with", bodyPayload);
	return fetch(loggingUrl, {
		method: "POST",
		headers: getRequestHeaders(),
		credentials: "include",
		mode: "cors",
		body: bodyPayload,
	}); // fetch
}
